export default __webpack_public_path__ + "static/media/relay.0285de10.png";